import * as React from 'react';
export const IcFoodDrink = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.71 8.71A1 1 0 0014 7h-2.72l.5-2H13a1 1 0 100-2h-1.22a2 2 0 00-1.23.43 2 2 0 00-.71 1.09L9.22 7H4a1 1 0 000 2h10a1 1 0 00.71-.29zM9 16a7.05 7.05 0 012.1-5H4.3l.7 9.08a1 1 0 00.32.66A1 1 0 006 21h5.11A7.05 7.05 0 019 16zm11.45-2.27a5 5 0 00-2.71-2.41 3.1 3.1 0 001.26-.76A3.86 3.86 0 0020 8a.51.51 0 00-.49-.49 3.38 3.38 0 00-1.37.23 3.34 3.34 0 00-1.14.8 3.71 3.71 0 00-.94 2.46 5 5 0 00-1 9.91 5 5 0 005.74-3.57 5.07 5.07 0 00-.34-3.61h-.01z'
      fill='currentColor'
    />
  </svg>
);
